<login-container titel="Log ind med..." (tilbage)="onNavigerTilOversigtClick()" [arbejder]="loginForbrugerNr.arbejder || loginEmail.arbejder">
    <mat-tab-group (selectedTabChange)="onSelectedTabChange($event)">
        <mat-tab label="Forbrugernummer">
            <login-forbrugernr
                id="login-forbruger-nummer"
                #loginForbrugerNr
                [parent]="form"
                (loginSucceeded)="onLoginSucceeded()"
                (alphaKeyPressed)="onForbrugerNrAlphaKeyPressed($event)"
            ></login-forbrugernr>
        </mat-tab>
        <mat-tab label="E-mail">
            <login-email #loginEmail id="login-email" [parent]="form" (loginSucceeded)="onLoginSucceeded()"></login-email>
        </mat-tab>
    </mat-tab-group>
</login-container>
